/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * ============================================================================
 * Countries Data
 * ============================================================================
 *
 * Complete list of all countries in the world with ISO codes and dial codes.
 * Organized alphabetically for easy searching.
 *
 * ============================================================================
 */

export interface Country {
  code: string;      // ISO 3166-1 alpha-2 code
  name: string;      // Full country name
  dialCode: string;  // International dial code
  flag: string;      // Flag emoji
}

export const countries: Country[] = [
  { code: 'AF', name: 'Afghanistan', dialCode: '+93', flag: '🇦🇫' },
  { code: 'AL', name: 'Albania', dialCode: '+355', flag: '🇦🇱' },
  { code: 'DZ', name: 'Algeria', dialCode: '+213', flag: '🇩🇿' },
  { code: 'AD', name: 'Andorra', dialCode: '+376', flag: '🇦🇩' },
  { code: 'AO', name: 'Angola', dialCode: '+244', flag: '🇦🇴' },
  { code: 'AG', name: 'Antigua and Barbuda', dialCode: '+1-268', flag: '🇦🇬' },
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'AM', name: 'Armenia', dialCode: '+374', flag: '🇦🇲' },
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'AZ', name: 'Azerbaijan', dialCode: '+994', flag: '🇦🇿' },
  { code: 'BS', name: 'Bahamas', dialCode: '+1-242', flag: '🇧🇸' },
  { code: 'BH', name: 'Bahrain', dialCode: '+973', flag: '🇧🇭' },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { code: 'BB', name: 'Barbados', dialCode: '+1-246', flag: '🇧🇧' },
  { code: 'BY', name: 'Belarus', dialCode: '+375', flag: '🇧🇾' },
  { code: 'BE', name: 'Belgium', dialCode: '+32', flag: '🇧🇪' },
  { code: 'BZ', name: 'Belize', dialCode: '+501', flag: '🇧🇿' },
  { code: 'BJ', name: 'Benin', dialCode: '+229', flag: '🇧🇯' },
  { code: 'BT', name: 'Bhutan', dialCode: '+975', flag: '🇧🇹' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'BA', name: 'Bosnia and Herzegovina', dialCode: '+387', flag: '🇧🇦' },
  { code: 'BW', name: 'Botswana', dialCode: '+267', flag: '🇧🇼' },
  { code: 'BR', name: 'Brazil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'BN', name: 'Brunei', dialCode: '+673', flag: '🇧🇳' },
  { code: 'BG', name: 'Bulgaria', dialCode: '+359', flag: '🇧🇬' },
  { code: 'BF', name: 'Burkina Faso', dialCode: '+226', flag: '🇧🇫' },
  { code: 'BI', name: 'Burundi', dialCode: '+257', flag: '🇧🇮' },
  { code: 'CV', name: 'Cabo Verde', dialCode: '+238', flag: '🇨🇻' },
  { code: 'KH', name: 'Cambodia', dialCode: '+855', flag: '🇰🇭' },
  { code: 'CM', name: 'Cameroon', dialCode: '+237', flag: '🇨🇲' },
  { code: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  { code: 'CF', name: 'Central African Republic', dialCode: '+236', flag: '🇨🇫' },
  { code: 'TD', name: 'Chad', dialCode: '+235', flag: '🇹🇩' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'KM', name: 'Comoros', dialCode: '+269', flag: '🇰🇲' },
  { code: 'CG', name: 'Congo', dialCode: '+242', flag: '🇨🇬' },
  { code: 'CD', name: 'Congo (DRC)', dialCode: '+243', flag: '🇨🇩' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷' },
  { code: 'CI', name: "Cote d'Ivoire", dialCode: '+225', flag: '🇨🇮' },
  { code: 'HR', name: 'Croatia', dialCode: '+385', flag: '🇭🇷' },
  { code: 'CU', name: 'Cuba', dialCode: '+53', flag: '🇨🇺' },
  { code: 'CY', name: 'Cyprus', dialCode: '+357', flag: '🇨🇾' },
  { code: 'CZ', name: 'Czech Republic', dialCode: '+420', flag: '🇨🇿' },
  { code: 'DK', name: 'Denmark', dialCode: '+45', flag: '🇩🇰' },
  { code: 'DJ', name: 'Djibouti', dialCode: '+253', flag: '🇩🇯' },
  { code: 'DM', name: 'Dominica', dialCode: '+1-767', flag: '🇩🇲' },
  { code: 'DO', name: 'Dominican Republic', dialCode: '+1-809', flag: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'EG', name: 'Egypt', dialCode: '+20', flag: '🇪🇬' },
  { code: 'SV', name: 'El Salvador', dialCode: '+503', flag: '🇸🇻' },
  { code: 'GQ', name: 'Equatorial Guinea', dialCode: '+240', flag: '🇬🇶' },
  { code: 'ER', name: 'Eritrea', dialCode: '+291', flag: '🇪🇷' },
  { code: 'EE', name: 'Estonia', dialCode: '+372', flag: '🇪🇪' },
  { code: 'SZ', name: 'Eswatini', dialCode: '+268', flag: '🇸🇿' },
  { code: 'ET', name: 'Ethiopia', dialCode: '+251', flag: '🇪🇹' },
  { code: 'FJ', name: 'Fiji', dialCode: '+679', flag: '🇫🇯' },
  { code: 'FI', name: 'Finland', dialCode: '+358', flag: '🇫🇮' },
  { code: 'FR', name: 'France', dialCode: '+33', flag: '🇫🇷' },
  { code: 'GA', name: 'Gabon', dialCode: '+241', flag: '🇬🇦' },
  { code: 'GM', name: 'Gambia', dialCode: '+220', flag: '🇬🇲' },
  { code: 'GE', name: 'Georgia', dialCode: '+995', flag: '🇬🇪' },
  { code: 'DE', name: 'Germany', dialCode: '+49', flag: '🇩🇪' },
  { code: 'GH', name: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'GR', name: 'Greece', dialCode: '+30', flag: '🇬🇷' },
  { code: 'GD', name: 'Grenada', dialCode: '+1-473', flag: '🇬🇩' },
  { code: 'GT', name: 'Guatemala', dialCode: '+502', flag: '🇬🇹' },
  { code: 'GN', name: 'Guinea', dialCode: '+224', flag: '🇬🇳' },
  { code: 'GW', name: 'Guinea-Bissau', dialCode: '+245', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', dialCode: '+592', flag: '🇬🇾' },
  { code: 'HT', name: 'Haiti', dialCode: '+509', flag: '🇭🇹' },
  { code: 'HN', name: 'Honduras', dialCode: '+504', flag: '🇭🇳' },
  { code: 'HU', name: 'Hungary', dialCode: '+36', flag: '🇭🇺' },
  { code: 'IS', name: 'Iceland', dialCode: '+354', flag: '🇮🇸' },
  { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'IR', name: 'Iran', dialCode: '+98', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraq', dialCode: '+964', flag: '🇮🇶' },
  { code: 'IE', name: 'Ireland', dialCode: '+353', flag: '🇮🇪' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'IT', name: 'Italy', dialCode: '+39', flag: '🇮🇹' },
  { code: 'JM', name: 'Jamaica', dialCode: '+1-876', flag: '🇯🇲' },
  { code: 'JP', name: 'Japan', dialCode: '+81', flag: '🇯🇵' },
  { code: 'JO', name: 'Jordan', dialCode: '+962', flag: '🇯🇴' },
  { code: 'KZ', name: 'Kazakhstan', dialCode: '+7', flag: '🇰🇿' },
  { code: 'KE', name: 'Kenya', dialCode: '+254', flag: '🇰🇪' },
  { code: 'KI', name: 'Kiribati', dialCode: '+686', flag: '🇰🇮' },
  { code: 'KP', name: 'North Korea', dialCode: '+850', flag: '🇰🇵' },
  { code: 'KR', name: 'South Korea', dialCode: '+82', flag: '🇰🇷' },
  { code: 'KW', name: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  { code: 'KG', name: 'Kyrgyzstan', dialCode: '+996', flag: '🇰🇬' },
  { code: 'LA', name: 'Laos', dialCode: '+856', flag: '🇱🇦' },
  { code: 'LV', name: 'Latvia', dialCode: '+371', flag: '🇱🇻' },
  { code: 'LB', name: 'Lebanon', dialCode: '+961', flag: '🇱🇧' },
  { code: 'LS', name: 'Lesotho', dialCode: '+266', flag: '🇱🇸' },
  { code: 'LR', name: 'Liberia', dialCode: '+231', flag: '🇱🇷' },
  { code: 'LY', name: 'Libya', dialCode: '+218', flag: '🇱🇾' },
  { code: 'LI', name: 'Liechtenstein', dialCode: '+423', flag: '🇱🇮' },
  { code: 'LT', name: 'Lithuania', dialCode: '+370', flag: '🇱🇹' },
  { code: 'LU', name: 'Luxembourg', dialCode: '+352', flag: '🇱🇺' },
  { code: 'MG', name: 'Madagascar', dialCode: '+261', flag: '🇲🇬' },
  { code: 'MW', name: 'Malawi', dialCode: '+265', flag: '🇲🇼' },
  { code: 'MY', name: 'Malaysia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'MV', name: 'Maldives', dialCode: '+960', flag: '🇲🇻' },
  { code: 'ML', name: 'Mali', dialCode: '+223', flag: '🇲🇱' },
  { code: 'MT', name: 'Malta', dialCode: '+356', flag: '🇲🇹' },
  { code: 'MH', name: 'Marshall Islands', dialCode: '+692', flag: '🇲🇭' },
  { code: 'MR', name: 'Mauritania', dialCode: '+222', flag: '🇲🇷' },
  { code: 'MU', name: 'Mauritius', dialCode: '+230', flag: '🇲🇺' },
  { code: 'MX', name: 'Mexico', dialCode: '+52', flag: '🇲🇽' },
  { code: 'FM', name: 'Micronesia', dialCode: '+691', flag: '🇫🇲' },
  { code: 'MD', name: 'Moldova', dialCode: '+373', flag: '🇲🇩' },
  { code: 'MC', name: 'Monaco', dialCode: '+377', flag: '🇲🇨' },
  { code: 'MN', name: 'Mongolia', dialCode: '+976', flag: '🇲🇳' },
  { code: 'ME', name: 'Montenegro', dialCode: '+382', flag: '🇲🇪' },
  { code: 'MA', name: 'Morocco', dialCode: '+212', flag: '🇲🇦' },
  { code: 'MZ', name: 'Mozambique', dialCode: '+258', flag: '🇲🇿' },
  { code: 'MM', name: 'Myanmar', dialCode: '+95', flag: '🇲🇲' },
  { code: 'NA', name: 'Namibia', dialCode: '+264', flag: '🇳🇦' },
  { code: 'NR', name: 'Nauru', dialCode: '+674', flag: '🇳🇷' },
  { code: 'NP', name: 'Nepal', dialCode: '+977', flag: '🇳🇵' },
  { code: 'NL', name: 'Netherlands', dialCode: '+31', flag: '🇳🇱' },
  { code: 'NZ', name: 'New Zealand', dialCode: '+64', flag: '🇳🇿' },
  { code: 'NI', name: 'Nicaragua', dialCode: '+505', flag: '🇳🇮' },
  { code: 'NE', name: 'Niger', dialCode: '+227', flag: '🇳🇪' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'MK', name: 'North Macedonia', dialCode: '+389', flag: '🇲🇰' },
  { code: 'NO', name: 'Norway', dialCode: '+47', flag: '🇳🇴' },
  { code: 'OM', name: 'Oman', dialCode: '+968', flag: '🇴🇲' },
  { code: 'PK', name: 'Pakistan', dialCode: '+92', flag: '🇵🇰' },
  { code: 'PW', name: 'Palau', dialCode: '+680', flag: '🇵🇼' },
  { code: 'PS', name: 'Palestine', dialCode: '+970', flag: '🇵🇸' },
  { code: 'PA', name: 'Panama', dialCode: '+507', flag: '🇵🇦' },
  { code: 'PG', name: 'Papua New Guinea', dialCode: '+675', flag: '🇵🇬' },
  { code: 'PY', name: 'Paraguay', dialCode: '+595', flag: '🇵🇾' },
  { code: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪' },
  { code: 'PH', name: 'Philippines', dialCode: '+63', flag: '🇵🇭' },
  { code: 'PL', name: 'Poland', dialCode: '+48', flag: '🇵🇱' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'QA', name: 'Qatar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'RO', name: 'Romania', dialCode: '+40', flag: '🇷🇴' },
  { code: 'RU', name: 'Russia', dialCode: '+7', flag: '🇷🇺' },
  { code: 'RW', name: 'Rwanda', dialCode: '+250', flag: '🇷🇼' },
  { code: 'KN', name: 'Saint Kitts and Nevis', dialCode: '+1-869', flag: '🇰🇳' },
  { code: 'LC', name: 'Saint Lucia', dialCode: '+1-758', flag: '🇱🇨' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', dialCode: '+1-784', flag: '🇻🇨' },
  { code: 'WS', name: 'Samoa', dialCode: '+685', flag: '🇼🇸' },
  { code: 'SM', name: 'San Marino', dialCode: '+378', flag: '🇸🇲' },
  { code: 'ST', name: 'Sao Tome and Principe', dialCode: '+239', flag: '🇸🇹' },
  { code: 'SA', name: 'Saudi Arabia', dialCode: '+966', flag: '🇸🇦' },
  { code: 'SN', name: 'Senegal', dialCode: '+221', flag: '🇸🇳' },
  { code: 'RS', name: 'Serbia', dialCode: '+381', flag: '🇷🇸' },
  { code: 'SC', name: 'Seychelles', dialCode: '+248', flag: '🇸🇨' },
  { code: 'SL', name: 'Sierra Leone', dialCode: '+232', flag: '🇸🇱' },
  { code: 'SG', name: 'Singapore', dialCode: '+65', flag: '🇸🇬' },
  { code: 'SK', name: 'Slovakia', dialCode: '+421', flag: '🇸🇰' },
  { code: 'SI', name: 'Slovenia', dialCode: '+386', flag: '🇸🇮' },
  { code: 'SB', name: 'Solomon Islands', dialCode: '+677', flag: '🇸🇧' },
  { code: 'SO', name: 'Somalia', dialCode: '+252', flag: '🇸🇴' },
  { code: 'ZA', name: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
  { code: 'SS', name: 'South Sudan', dialCode: '+211', flag: '🇸🇸' },
  { code: 'ES', name: 'Spain', dialCode: '+34', flag: '🇪🇸' },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94', flag: '🇱🇰' },
  { code: 'SD', name: 'Sudan', dialCode: '+249', flag: '🇸🇩' },
  { code: 'SR', name: 'Suriname', dialCode: '+597', flag: '🇸🇷' },
  { code: 'SE', name: 'Sweden', dialCode: '+46', flag: '🇸🇪' },
  { code: 'CH', name: 'Switzerland', dialCode: '+41', flag: '🇨🇭' },
  { code: 'SY', name: 'Syria', dialCode: '+963', flag: '🇸🇾' },
  { code: 'TW', name: 'Taiwan', dialCode: '+886', flag: '🇹🇼' },
  { code: 'TJ', name: 'Tajikistan', dialCode: '+992', flag: '🇹🇯' },
  { code: 'TZ', name: 'Tanzania', dialCode: '+255', flag: '🇹🇿' },
  { code: 'TH', name: 'Thailand', dialCode: '+66', flag: '🇹🇭' },
  { code: 'TL', name: 'Timor-Leste', dialCode: '+670', flag: '🇹🇱' },
  { code: 'TG', name: 'Togo', dialCode: '+228', flag: '🇹🇬' },
  { code: 'TO', name: 'Tonga', dialCode: '+676', flag: '🇹🇴' },
  { code: 'TT', name: 'Trinidad and Tobago', dialCode: '+1-868', flag: '🇹🇹' },
  { code: 'TN', name: 'Tunisia', dialCode: '+216', flag: '🇹🇳' },
  { code: 'TR', name: 'Turkey', dialCode: '+90', flag: '🇹🇷' },
  { code: 'TM', name: 'Turkmenistan', dialCode: '+993', flag: '🇹🇲' },
  { code: 'TV', name: 'Tuvalu', dialCode: '+688', flag: '🇹🇻' },
  { code: 'UG', name: 'Uganda', dialCode: '+256', flag: '🇺🇬' },
  { code: 'UA', name: 'Ukraine', dialCode: '+380', flag: '🇺🇦' },
  { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', flag: '🇦🇪' },
  { code: 'GB', name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
  { code: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', dialCode: '+998', flag: '🇺🇿' },
  { code: 'VU', name: 'Vanuatu', dialCode: '+678', flag: '🇻🇺' },
  { code: 'VA', name: 'Vatican City', dialCode: '+379', flag: '🇻🇦' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳' },
  { code: 'YE', name: 'Yemen', dialCode: '+967', flag: '🇾🇪' },
  { code: 'ZM', name: 'Zambia', dialCode: '+260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', dialCode: '+263', flag: '🇿🇼' },
];

/**
 * Get country by ISO code
 */
export const getCountryByCode = (code: string): Country | undefined => {
  return countries.find(c => c.code === code);
};

/**
 * Get country by name
 */
export const getCountryByName = (name: string): Country | undefined => {
  return countries.find(c => c.name.toLowerCase() === name.toLowerCase());
};

/**
 * Search countries by name (partial match)
 */
export const searchCountries = (query: string): Country[] => {
  if (!query.trim()) return countries;
  const lowerQuery = query.toLowerCase();
  return countries.filter(c =>
    c.name.toLowerCase().includes(lowerQuery) ||
    c.code.toLowerCase().includes(lowerQuery)
  );
};

// ============================================================================
// COUNTRY-SPECIFIC CONFIGURATION
// ============================================================================

/**
 * Country-specific configuration for forms and localization
 */
export interface CountryConfig {
  /** Phone number placeholder format */
  phonePlaceholder: string;
  /** Tax identification label (e.g., NIF, TIN, VAT) */
  taxIdLabel: string;
  /** Tax ID placeholder format */
  taxIdPlaceholder: string;
  /** Business registry label (e.g., RCCM, RC, Company Number) */
  businessRegistryLabel: string | null;
  /** Business registry placeholder */
  businessRegistryPlaceholder: string | null;
  /** Default currency code */
  defaultCurrency: string;
  /** Capital city (for placeholder) */
  capital: string;
}

/**
 * Country-specific configurations
 * Focus on West African countries and major markets
 */
const countryConfigs: Record<string, CountryConfig> = {
  // West Africa - ECOWAS countries
  GN: { // Guinea
    phonePlaceholder: '+224 6XX XXX XXX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'GN-XXXX-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'GN-CKY-XXXX-X-XXXX',
    defaultCurrency: 'GNF',
    capital: 'Conakry',
  },
  ML: { // Mali
    phonePlaceholder: '+223 XX XX XX XX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'ML-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'BKO-XXXX-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Bamako',
  },
  SN: { // Senegal
    phonePlaceholder: '+221 7X XXX XX XX',
    taxIdLabel: 'NINEA',
    taxIdPlaceholder: 'XXXXXXX XX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'SN-DKR-XXXX-X-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Dakar',
  },
  CI: { // Côte d'Ivoire
    phonePlaceholder: '+225 XX XX XX XX XX',
    taxIdLabel: 'NCC',
    taxIdPlaceholder: 'CI-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'CI-ABJ-XXXX-X-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Abidjan',
  },
  BF: { // Burkina Faso
    phonePlaceholder: '+226 XX XX XX XX',
    taxIdLabel: 'IFU',
    taxIdPlaceholder: 'BF-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'BF-OUA-XXXX-X-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Ouagadougou',
  },
  NE: { // Niger
    phonePlaceholder: '+227 XX XX XX XX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'NE-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'NE-NIA-XXXX-X-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Niamey',
  },
  TG: { // Togo
    phonePlaceholder: '+228 XX XX XX XX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'TG-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'TG-LOM-XXXX-X-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Lomé',
  },
  BJ: { // Benin
    phonePlaceholder: '+229 XX XX XX XX',
    taxIdLabel: 'IFU',
    taxIdPlaceholder: 'BJ-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'BJ-COT-XXXX-X-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Cotonou',
  },
  GH: { // Ghana
    phonePlaceholder: '+233 XX XXX XXXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'GHA-XXXXXXXXX-X',
    businessRegistryLabel: 'Company Number',
    businessRegistryPlaceholder: 'CS-XXXXXX-XX',
    defaultCurrency: 'GHS',
    capital: 'Accra',
  },
  NG: { // Nigeria
    phonePlaceholder: '+234 XXX XXX XXXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'XXXXXXXXXX',
    businessRegistryLabel: 'RC Number',
    businessRegistryPlaceholder: 'RC-XXXXXXX',
    defaultCurrency: 'NGN',
    capital: 'Lagos',
  },
  GW: { // Guinea-Bissau
    phonePlaceholder: '+245 XXX XXXX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'GW-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'GW-BIS-XXXX-X-XXXX',
    defaultCurrency: 'XOF',
    capital: 'Bissau',
  },
  GM: { // Gambia
    phonePlaceholder: '+220 XXX XXXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'GM-XXXXXXXX',
    businessRegistryLabel: 'Company Number',
    businessRegistryPlaceholder: 'GM-XXXXXX',
    defaultCurrency: 'GMD',
    capital: 'Banjul',
  },
  SL: { // Sierra Leone
    phonePlaceholder: '+232 XX XXX XXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'SL-XXXXXXXX',
    businessRegistryLabel: 'Company Number',
    businessRegistryPlaceholder: 'SL-XXXXXX',
    defaultCurrency: 'SLL',
    capital: 'Freetown',
  },
  LR: { // Liberia
    phonePlaceholder: '+231 XXX XXX XXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'LR-XXXXXXXX',
    businessRegistryLabel: 'Company Number',
    businessRegistryPlaceholder: 'LR-XXXXXX',
    defaultCurrency: 'LRD',
    capital: 'Monrovia',
  },
  CV: { // Cabo Verde
    phonePlaceholder: '+238 XXX XX XX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'CV-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'CV-PRA-XXXX-X-XXXX',
    defaultCurrency: 'CVE',
    capital: 'Praia',
  },
  // Central Africa
  CM: { // Cameroon
    phonePlaceholder: '+237 6XX XXX XXX',
    taxIdLabel: 'NIU',
    taxIdPlaceholder: 'M-XXXXXXX-X',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'CM-YDE-XXXX-X-XXXX',
    defaultCurrency: 'XAF',
    capital: 'Yaoundé',
  },
  GA: { // Gabon
    phonePlaceholder: '+241 XX XX XX XX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'GA-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'GA-LBV-XXXX-X-XXXX',
    defaultCurrency: 'XAF',
    capital: 'Libreville',
  },
  CG: { // Congo
    phonePlaceholder: '+242 XX XXX XXXX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'CG-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'CG-BZV-XXXX-X-XXXX',
    defaultCurrency: 'XAF',
    capital: 'Brazzaville',
  },
  CD: { // DR Congo
    phonePlaceholder: '+243 XX XXX XXXX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'CD-XXXXXXXX',
    businessRegistryLabel: 'RCCM',
    businessRegistryPlaceholder: 'CD-KIN-XXXX-X-XXXX',
    defaultCurrency: 'CDF',
    capital: 'Kinshasa',
  },
  // North Africa
  MA: { // Morocco
    phonePlaceholder: '+212 6XX XXX XXX',
    taxIdLabel: 'ICE',
    taxIdPlaceholder: 'XXXXXXXXXXXXXXX',
    businessRegistryLabel: 'RC',
    businessRegistryPlaceholder: 'XXXXXX',
    defaultCurrency: 'MAD',
    capital: 'Casablanca',
  },
  DZ: { // Algeria
    phonePlaceholder: '+213 XXX XX XX XX',
    taxIdLabel: 'NIF',
    taxIdPlaceholder: 'XXXXXXXXXXXXXXX',
    businessRegistryLabel: 'RC',
    businessRegistryPlaceholder: 'XX/XX-XXXXXXX',
    defaultCurrency: 'DZD',
    capital: 'Algiers',
  },
  TN: { // Tunisia
    phonePlaceholder: '+216 XX XXX XXX',
    taxIdLabel: 'MF',
    taxIdPlaceholder: 'XXXXXXX/X/X/X/XXX',
    businessRegistryLabel: 'RC',
    businessRegistryPlaceholder: 'BXXXXXXX',
    defaultCurrency: 'TND',
    capital: 'Tunis',
  },
  EG: { // Egypt
    phonePlaceholder: '+20 XXX XXX XXXX',
    taxIdLabel: 'Tax Card',
    taxIdPlaceholder: 'XXX-XXX-XXX',
    businessRegistryLabel: 'Commercial Register',
    businessRegistryPlaceholder: 'XXXXX',
    defaultCurrency: 'EGP',
    capital: 'Cairo',
  },
  // Major Markets
  FR: { // France
    phonePlaceholder: '+33 X XX XX XX XX',
    taxIdLabel: 'SIRET',
    taxIdPlaceholder: 'XXX XXX XXX XXXXX',
    businessRegistryLabel: 'RCS',
    businessRegistryPlaceholder: 'XXX XXX XXX RCS Paris',
    defaultCurrency: 'EUR',
    capital: 'Paris',
  },
  GB: { // United Kingdom
    phonePlaceholder: '+44 XXXX XXXXXX',
    taxIdLabel: 'VAT Number',
    taxIdPlaceholder: 'GB XXX XXXX XX',
    businessRegistryLabel: 'Company Number',
    businessRegistryPlaceholder: 'XXXXXXXX',
    defaultCurrency: 'GBP',
    capital: 'London',
  },
  US: { // United States
    phonePlaceholder: '+1 (XXX) XXX-XXXX',
    taxIdLabel: 'EIN',
    taxIdPlaceholder: 'XX-XXXXXXX',
    businessRegistryLabel: 'State Registration',
    businessRegistryPlaceholder: 'State-specific',
    defaultCurrency: 'USD',
    capital: 'Washington D.C.',
  },
  DE: { // Germany
    phonePlaceholder: '+49 XXX XXXXXXXX',
    taxIdLabel: 'USt-IdNr',
    taxIdPlaceholder: 'DE XXXXXXXXX',
    businessRegistryLabel: 'Handelsregister',
    businessRegistryPlaceholder: 'HRB XXXXX',
    defaultCurrency: 'EUR',
    capital: 'Berlin',
  },
  AE: { // UAE
    phonePlaceholder: '+971 XX XXX XXXX',
    taxIdLabel: 'TRN',
    taxIdPlaceholder: 'XXXXXXXXXXXXXXX',
    businessRegistryLabel: 'Trade License',
    businessRegistryPlaceholder: 'XXXXXX',
    defaultCurrency: 'AED',
    capital: 'Dubai',
  },
  SA: { // Saudi Arabia
    phonePlaceholder: '+966 5X XXX XXXX',
    taxIdLabel: 'VAT Number',
    taxIdPlaceholder: 'XXXXXXXXXXXXXXX',
    businessRegistryLabel: 'CR Number',
    businessRegistryPlaceholder: 'XXXXXXXXXX',
    defaultCurrency: 'SAR',
    capital: 'Riyadh',
  },
  IN: { // India
    phonePlaceholder: '+91 XXXXX XXXXX',
    taxIdLabel: 'GSTIN',
    taxIdPlaceholder: 'XXAAAAAAAAAAXZX',
    businessRegistryLabel: 'CIN',
    businessRegistryPlaceholder: 'UXXXXX XX XXXX XXXXXX',
    defaultCurrency: 'INR',
    capital: 'New Delhi',
  },
  CN: { // China
    phonePlaceholder: '+86 XXX XXXX XXXX',
    taxIdLabel: 'Tax ID',
    taxIdPlaceholder: 'XXXXXXXXXXXXXXXXXX',
    businessRegistryLabel: 'Business License',
    businessRegistryPlaceholder: 'XXXXXXXXXXXXXXXXXX',
    defaultCurrency: 'CNY',
    capital: 'Beijing',
  },
  ZA: { // South Africa
    phonePlaceholder: '+27 XX XXX XXXX',
    taxIdLabel: 'Tax Number',
    taxIdPlaceholder: 'XXXXXXXXXX',
    businessRegistryLabel: 'CIPC Number',
    businessRegistryPlaceholder: 'XXXX/XXXXXX/XX',
    defaultCurrency: 'ZAR',
    capital: 'Johannesburg',
  },
  KE: { // Kenya
    phonePlaceholder: '+254 7XX XXX XXX',
    taxIdLabel: 'KRA PIN',
    taxIdPlaceholder: 'AXXXXXXXXX',
    businessRegistryLabel: 'Company Number',
    businessRegistryPlaceholder: 'CPR/XXXX/XXXXX',
    defaultCurrency: 'KES',
    capital: 'Nairobi',
  },
  RW: { // Rwanda
    phonePlaceholder: '+250 7XX XXX XXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'XXXXXXXXX',
    businessRegistryLabel: 'Company Code',
    businessRegistryPlaceholder: 'XXXXXXXXX',
    defaultCurrency: 'RWF',
    capital: 'Kigali',
  },
  ET: { // Ethiopia
    phonePlaceholder: '+251 9X XXX XXXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'XXXXXXXXXX',
    businessRegistryLabel: 'Business License',
    businessRegistryPlaceholder: 'XXXXXXXXXX',
    defaultCurrency: 'ETB',
    capital: 'Addis Ababa',
  },
  TZ: { // Tanzania
    phonePlaceholder: '+255 7XX XXX XXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'XXX-XXX-XXX',
    businessRegistryLabel: 'BRELA Number',
    businessRegistryPlaceholder: 'XXXXXXXXXX',
    defaultCurrency: 'TZS',
    capital: 'Dar es Salaam',
  },
  UG: { // Uganda
    phonePlaceholder: '+256 7XX XXX XXX',
    taxIdLabel: 'TIN',
    taxIdPlaceholder: 'XXXXXXXXXX',
    businessRegistryLabel: 'Company Number',
    businessRegistryPlaceholder: 'XXXXXXXXXX',
    defaultCurrency: 'UGX',
    capital: 'Kampala',
  },
};

/**
 * Default configuration for countries without specific config
 */
const defaultConfig: CountryConfig = {
  phonePlaceholder: '+XXX XXX XXX XXX',
  taxIdLabel: 'Tax ID',
  taxIdPlaceholder: 'XXXXXXXXXXXX',
  businessRegistryLabel: 'Business Registration',
  businessRegistryPlaceholder: 'XXXXXXXXXXXX',
  defaultCurrency: 'USD',
  capital: '',
};

/**
 * Get country-specific configuration
 * Falls back to default if country not found
 */
export const getCountryConfig = (countryCode: string): CountryConfig => {
  return countryConfigs[countryCode] || defaultConfig;
};

/**
 * Get country config by country name
 */
export const getCountryConfigByName = (countryName: string): CountryConfig => {
  const country = getCountryByName(countryName);
  if (country) {
    return getCountryConfig(country.code);
  }
  return defaultConfig;
};

/**
 * Check if a country has specific configuration
 */
export const hasCountryConfig = (countryCode: string): boolean => {
  return countryCode in countryConfigs;
};

export default countries;
